import React from "react";

import Signup from "../Signup";
import {
    PageTitle,
    PageSubtitle,
    PageWrapper,
    PageFormContent
} from "../styles";

import { afterSocialAuth } from "frontend/hooks/useAuth";

const FacebookSignupPage = () => (
    <PageWrapper darkMode>
        <PageTitle darkMode>One Last Step</PageTitle>
        <PageSubtitle>
            Make sure your information from Facebook is correct.
        </PageSubtitle>
        <PageFormContent>
            <Signup isSocialSignup afterAuth={afterSocialAuth} />
        </PageFormContent>
    </PageWrapper>
);

export default FacebookSignupPage;
